import { render, staticRenderFns } from "./WeekFilter.vue?vue&type=template&id=3031701a&"
import script from "./WeekFilter.vue?vue&type=script&lang=js&"
export * from "./WeekFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports